import React from 'react';
import { loanHeader } from '../../data/withdraw';
interface LoanHeaderProps {
  lender: string;
  className?: string;
}
export function LoanHeader({
  lender,
  className = ''
}: LoanHeaderProps) {
  return <div className={`flex flex-wrap items-center gap-x-6 gap-y-3 rounded-2xl bg-white px-4 py-3 shadow-soft ring-1 ring-slate-900/5 ${className}`} data-id="element-97" data-mp="2wsx648g363yw">
      <div className="flex items-center gap-3" data-id="element-98" data-mp="2rwzv8hnldpti">
        <span className="grid h-10 w-10 place-items-center rounded-full bg-primary-100 text-sm font-bold text-primary-800" data-id="element-99" data-mp="3phcisobqwa72">
          {loanHeader.initials}
        </span>
        <div data-id="element-100" data-mp="3fs2nkzllubeq">
          <p className="text-sm font-semibold text-slate-900" data-id="element-101" data-mp="3frsw17kwvw6x">{loanHeader.borrower}</p>
          <p className="text-xs text-slate-500" data-id="element-102" data-mp="3au17mnjh6s7h">
            Loan # <span className="font-medium tabular-nums text-slate-700" data-id="element-103" data-mp="3arf02nwl4cp9">{loanHeader.loanNumber}</span>
          </p>
        </div>
      </div>
      <dl className="flex items-center gap-6 sm:ml-auto" data-id="element-104" data-mp="7c97glv6r1y7">
        <div className="border-l border-slate-200 pl-6 sm:border-l-0 sm:pl-0" data-id="element-105" data-mp="7aociv4ylgzt">
          <dt className="text-[11px] font-medium text-slate-500" data-id="element-106" data-mp="1q3yascpa5qka">Lender</dt>
          <dd className="text-sm font-semibold text-slate-800" data-id="element-107" data-mp="1v2stzfr5th4x">{lender}</dd>
        </div>
        <div className="border-l border-slate-200 pl-6" data-id="element-108" data-mp="1ge4w32tucvbt">
          <dt className="text-[11px] font-medium text-slate-500" data-id="element-109" data-mp="1gbiox4av4hu4">Stage</dt>
          <dd className="mt-0.5" data-id="element-110" data-mp="1lb56tr1mym99">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-50 px-2.5 py-0.5 text-xs font-semibold text-accent-700" data-id="element-111" data-mp="17cyesrjdbghi">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" data-id="element-112" data-mp="1bfl9r1bc5hix" />
              {loanHeader.stage}
            </span>
          </dd>
        </div>
      </dl>
    </div>;
}